import Vue from "vue";
Vue.mixin({
    methods: {
        checkPermission(permission) {
            return this.$store.state.permissions.includes(permission);
        }
    }
})